import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SvgMatType } from 'src/app/constants/icons';
import { BenefitWizardType } from 'src/app/constants/wizard-panels';
import { BenefitSummary, BenefitSummaryList, BenefitTotal, CafeteriaSummaryTotalCard, RequestedEOI } from 'src/app/models/benefit-summary';
import { TableColumn, ToggleColumnProperty } from 'src/app/models/table';
import { EnrollmentManagerService } from 'src/app/services/enrollment-manager.service';
import { trigger, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'mwp-card-benefit-summary',
    templateUrl: './card-benefit-summary.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [
        trigger('slideDown', [
            transition(':enter', [
                style({ height: '0', opacity: 0, }),
                animate(
                    '.25s ease-in-out',
                    style({ height: '*', opacity: 1, })
                )
            ]),
            transition(':leave', [
                style({ height: '*', opacity: 1, }),
                animate(
                    '.25s ease-in-out',
                    style({ height: 0, opacity: 0, })
                )
            ])
        ])
    ]
})
export class CardBenefitSummaryComponent implements OnInit {
    @Input() public header: string;
    @Input() public deductionsHeader: string;
    @Input() public benefitSummaryList: BenefitSummaryList;
    @Input() public showSummary: boolean = true;
    @Input() public displayCategoryColumn: boolean;
    @Input() public displayBenefitColumn: boolean;
    @Input() public displayProcessColumn: boolean;
    @Input() public enableToggle: boolean;
    @Input() public showSummaryGridOnly: boolean;
    @Input() public isNoBorder: boolean;
    @Input() public isEnrollmentCheckout: boolean;
    @Input() public isEnrollmentSummary: boolean;
    @Input() public colSpanWidth: string = '7%';

    public benefitCards: BenefitSummary[];
    public totalCards: BenefitTotal[];
    public cafeteriaTotalCard: CafeteriaSummaryTotalCard;
    public showCafeteriaSummaryTotal: boolean;
    public showSummaryTotal: boolean;
    public displayInfoColumn: boolean;
    public displayForm: boolean;

    public svgType = SvgMatType;
    public selectedBenefituniqueID: string;

    isAddBuyupWizard: boolean;

    constructor(
        private enrollmentManagerService: EnrollmentManagerService
    ) {
    }
    
    ngOnInit(): void {
        if (this.isEnrollmentSummary) {
            this.isAddBuyupWizard = this.enrollmentManagerService.benefitWizardControlPanel.wizardType == BenefitWizardType.Add || this.enrollmentManagerService.benefitWizardControlPanel.wizardType == BenefitWizardType.BuyUp;
        }
        this.benefitCards = this.benefitSummaryList.summaryBenefitCards;
        this.totalCards = this.benefitSummaryList.summaryTotalCards;
        this.cafeteriaTotalCard = this.benefitSummaryList.cafeteriaSummaryTotalCard;
        this.showCafeteriaSummaryTotal = this.benefitSummaryList.showCafeteriaSummaryTotal;
        this.showSummaryTotal = this.benefitSummaryList.showSummaryTotal;
        
        this.benefitSummaryList.summaryBenefitCards.some((sbc: BenefitSummary) => {
            this.displayInfoColumn = sbc.coveredMembers?.length > 0 || sbc.requestedEOIs?.length > 0;
            if (this.displayInfoColumn)
                return true;

            return false;
        });

        if (this.showSummary)
            this.showSummary = this.showSummaryTotal || this.showCafeteriaSummaryTotal;
        this.displayForm = !this.showSummaryGridOnly;
    }

    public benefitHasPendingEOI(benefitSummary: BenefitSummary): boolean {
        return benefitSummary.showModal && benefitSummary.requestedEOIs.some((requestedEOI: RequestedEOI) =>
            requestedEOI.pendUnderWriting
        );
    }

    public displayIconButton(element: any, tableColumn: TableColumn): boolean {
        let l_Display: boolean;

        if (!tableColumn.toggleProperties)
            return true;

        tableColumn.toggleProperties.forEach((tp: ToggleColumnProperty) => {
            if (!l_Display && element[tp.propertyId])
                l_Display = element[tp.propertyId].length > 0;
        });

        return l_Display;
    }

    public toggleRow(element: BenefitSummary) {
        if (this.selectedBenefituniqueID == element.uniqueID) {
            this.selectedBenefituniqueID = null;
            return;
        }

        this.selectedBenefituniqueID = element.uniqueID;
    }
}